import { BarChart, ChartHeader } from "@msuite/ui/charts";
import { DashboardTile } from "@msuite/ui/dashboard";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { client } from "@/hono";
import type { DashboardTileProps } from "../shared";

export function Dashboard7DaysForecastItem({ item }: DashboardTileProps) {
	const { t } = useTranslation();

	const { data } = useQuery({
		queryKey: ["dashboard", "7-days-forecast"],
		queryFn: async () => {
			const response = await client.dashboard["seven-days-forecast"].$get();
			const data = await responseHandler(response);
			return data;
		},
	});

	/** Render */
	return (
		<DashboardTile item={item}>
			<div className="v-stack w-full h-full">
				<ChartHeader title={t("dashboard.7_days_forecast")} />
				<BarChart
					data={guardArray(data?.sevenDaysForecast)}
					dataKeys={["ticketsTotalCount", "userTicketsCount"]}
					displayKeyMap={{
						ticketsTotalCount: t("dashboard.tickets_total_count"),
						userTicketsCount: t("dashboard.user_tickets_count"),
					}}
					xTickFormatter={(item) => {
						return moment(item.name).format("dd");
					}}
				/>
			</div>
		</DashboardTile>
	);
}
